import {commentAxios} from "../commentAxios";

export const likeComment = (payload) => {
    return commentAxios.put(`/comments/like`, payload);
};
